import $ from 'jquery';
import { repository as coverCalendarRepository } from 'repositories/coverCalendarRepository';
import { coverCalendarModel } from 'models/CoverCalendarModel';
import CoverHeadingView from 'ui/cover/cover-heading-view';
import CoversView from 'ui/cover/covers-view';
import moment from 'moment/moment';

export const init = (params) => {

    $(window).ready(() => {

      setTimeout(() => {

        const data = jQuery.extend({}, window.journal);
        coverCalendarModel.fromJSON(data);

        const coverHeadingView = new CoverHeadingView(coverCalendarModel);
        const coversView = new CoversView(coverCalendarModel);

        coverHeadingView.render();
        coversView.init();

      }, 1000);
    });
};

export default { init };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/cover/index.js